import AdBlockDetector from 'shared/ad_block_detector';
import { IsAllowedPlatform } from 'shared/validation_helpers';
import { getPlatform, LocationMediator, QueryString } from 'shared/vidio_helpers';
import AhoyEvent from 'shared/ahoy_event';

const determinePlatform = () => {
  const url = LocationMediator.href();
  const platformParam = QueryString.getParamValue(url, 'tracking-platform');
  return IsAllowedPlatform(platformParam) ? platformParam : getPlatform();
}

const AhoyPageviewEvent = {
  sendEvent: function() {
    var eventProperties = {
      app_name     : 'vidio',
      page         : LocationMediator.href(),
      referrer     : document.referrer,
      platform     : determinePlatform(),
      has_adblocker: AdBlockDetector.hasAdBlocker()
    };

    AhoyEvent.send('PAGEVIEW', eventProperties);
  },
};

export default AhoyPageviewEvent;
